/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

import { useDropzone } from 'react-dropzone';

import Upload from '../../icons/Upload';
import defaultConfig from './defaultConfig';

const FileDropZone = ({
  config = {},
  mediaFileLimitReached = false,
  buttonClass = '',
  buttonText = '',
  children = null,
  containerClass = '',
  iconClass = '',
  iconColor = '',
}) => {
  const { getRootProps, getInputProps, open } = useDropzone({ ...defaultConfig, ...config });
  return (
    <>
      {/* eslint-disable react/jsx-props-no-spreading */}
      <section className={containerClass} {...getRootProps()}>
        {children}
        <input {...getInputProps()} />
        <button type="button" className={buttonClass} onClick={open} disabled={mediaFileLimitReached}>
          <Upload className={iconClass} color={iconColor} />
          <span>{buttonText}</span>
        </button>
      </section>
    </>
  );
};

FileDropZone.propTypes = {
  mediaFileLimitReached: PropTypes.bool,
  buttonClass: PropTypes.string,
  buttonText: PropTypes.string,
  children: PropTypes.node,
  containerClass: PropTypes.string,
  iconClass: PropTypes.string,
  iconColor: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  config: PropTypes.object,
};

export default FileDropZone;
